import { Select } from 'client/components/core/Sidebar/components/Settings/components'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities/index'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import usePageRouteDetector from 'client/hooks/usePageRouteDetector'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { blogPageTypes } from 'common/constants/pageTypes'
import {
  ButtonActionTypeEnum,
  buttonActionsNames,
  getButtonActions,
} from 'common/enums/ButtonActionTypeEnum'
import React, { useEffect } from 'react'
import { ButtonWebsiteLinkActionSettings } from 'src/editor/shared/entities/button-new/button-settings/button-website-link-action-settings'
import { ButtonBlogLinkActionSettings } from 'src/editor/shared/settings/button/button-blog-link-action-settings'
import { ButtonDownloadFileActionSettings } from 'src/editor/shared/settings/button/button-download-file-action-settings'
import { ButtonOpenUrlActionSettings } from 'src/editor/shared/settings/button/button-open-url-action-settings'
import { ButtonSendFormActionSettings } from 'src/editor/shared/settings/button/button-send-form-action-settings'
import { ButtonShowPopupActionSettings } from 'src/editor/shared/settings/button/button-show-popup-action-settings'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'

export const ButtonActionsSettings = ({
  entity,
}: SettingsProps<ActionButtonEntityInterface>) => {
  const updateProp = useUpdateProp(entity)
  const pageType = usePage(pageSelectors.getPageType)
  const { isWebsite } = usePageRouteDetector()

  const pageButtonActions = getButtonActions(pageType)
  const availableButtonActions = pageButtonActions.reduce(
    (actions, action) => {
      if (buttonActionsNames[action]) {
        actions[action] = buttonActionsNames[action]
      }
      return actions
    },
    {} as Record<ButtonActionTypeEnum, string>,
  )

  useEffect(() => {
    if (
      entity.action &&
      pageButtonActions.length &&
      !pageButtonActions.includes(entity.action)
    ) {
      updateProp('action')(
        pageButtonActions[0] as ActionButtonEntityInterface['action'],
      )
    }
  }, [entity.action, pageButtonActions])

  useEffect(() => {
    if (
      entity.action === ButtonActionTypeEnum.NextStepRedirection &&
      (blogPageTypes.includes(pageType) || isWebsite)
    ) {
      updateProp('action')(ButtonActionTypeEnum.OpenUrl)
    }
  }, [entity.action])

  return (
    <>
      {!!pageButtonActions.length && (
        <Select
          update={updateProp('action')}
          choiceList={availableButtonActions}
          labelText="Button action"
          value={entity.action}
        />
      )}
      <ButtonDownloadFileActionSettings entity={entity} />
      <ButtonOpenUrlActionSettings entity={entity} />
      <ButtonBlogLinkActionSettings entity={entity} />
      <ButtonWebsiteLinkActionSettings entity={entity} />
      <ButtonShowPopupActionSettings entity={entity} />
      <ButtonSendFormActionSettings entity={entity} />
    </>
  )
}
